/* @flow */

import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { JssProvider } from 'react-jss';
import { Provider } from 'react-redux';
import { CacheProvider } from '@emotion/react';
import { BrowserRouter } from 'react-router-dom';
import { HeadProvider } from 'react-head';
import createEmotionCache from 'src/shared/app/base/component/document/createEmotionCache';

import App from 'src/shared/app/base/component/App';
import { isDevModeEnabled } from 'src/shared/app/base/selector/appEnvSelectors';
import { getLocale } from 'src/shared/app/locale/selector/localeSelectors';

import type { Store } from 'src/shared/core/type/reduxTypes';

const cache = createEmotionCache();

type Props = {
  store: Store,
  messages?: Object,
};

const ClientApp = ({ store, messages }: Props): React.Node => {
  const state = store.getState();

  return (
    <HeadProvider>
      <CacheProvider value={cache}>
        <Provider store={store}>
          <IntlProvider locale={getLocale(state)} messages={messages}>
            <BrowserRouter>
              <JssProvider id={{ minify: !isDevModeEnabled(state) }}>
                <App />
              </JssProvider>
            </BrowserRouter>
          </IntlProvider>
        </Provider>
      </CacheProvider>
    </HeadProvider>
  );
};

export default React.memo<Props>(ClientApp);
